module.exports = __webpack_public_path__ + "img/1482737925.4a056886.jpg";